import { Dayjs } from "dayjs";
import RepositoryBase from "./RepositoryBase";
import { ResponseEnvelope } from "./RepositoryBase";
import GetBalanceStateResponse from "./BalanceStateResponses/GetBalanceStateResponse";
import GetAllBalanceStatesResponse from "./BalanceStateResponses/GetAllBalanceStatesResponse";
import DeleteBalanceStateResponse from "./BalanceStateResponses/DeleteBalanceStateResponse";
import AddBalanceStateResponse from "./BalanceStateResponses/AddBalanceStateResponse";
import GetLatestBalanceStateResponse from "./BalanceStateResponses/GetLatestBalanceStateResponse";

export default class BalanceStateRepository extends RepositoryBase {

    public static async getBalanceStateById(locationId: string, balanceStateId: string): Promise<ResponseEnvelope<GetBalanceStateResponse>> {
        try {
            const csrf = await this.getCsrf();
            if (csrf.isFailed()) return new ResponseEnvelope<GetBalanceStateResponse>(false, undefined, csrf.errorTitle, csrf.errorMessage);
            const token = csrf.result!;

            var response = await fetch(`${this.protocol}://${this.ip}:${this.port}/api/${locationId}/balancestate/${balanceStateId}`, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
            });

            if (!response.ok) return this.invalidResponse();

            var data = await response.json();
            if (!data.success) return this.requestUnsuccessful();

            return new ResponseEnvelope<GetBalanceStateResponse>(
                true,
                data as GetBalanceStateResponse
            );
        } catch (err) {
            if (err instanceof SyntaxError) {
                return this.invalidFormat();
            } else if (err instanceof TypeError) {
                return this.unableToSendRequest();
            } else {
                console.log(err);
                return this.unexpectedError();
            }
        }
    }

    public static async getLatestBalanceStateById(locationId: string): Promise<ResponseEnvelope<GetLatestBalanceStateResponse>> {
        try {
            const csrf = await this.getCsrf();
            if (csrf.isFailed()) return new ResponseEnvelope<GetLatestBalanceStateResponse>(false, undefined, csrf.errorTitle, csrf.errorMessage);
            const token = csrf.result!;

            var response = await fetch(`${this.protocol}://${this.ip}:${this.port}/api/${locationId}/balancestate/latest`, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
            });

            if (!response.ok) return this.invalidResponse();

            var data = await response.json();
            if (!data.success) return this.requestUnsuccessful();

            return new ResponseEnvelope<GetLatestBalanceStateResponse>(
                true,
                data as GetLatestBalanceStateResponse
            );
        } catch (err) {
            if (err instanceof SyntaxError) {
                return this.invalidFormat();
            } else if (err instanceof TypeError) {
                return this.unableToSendRequest();
            } else {
                console.log(err);
                return this.unexpectedError();
            }
        }
    }

    public static async getAllBalanceStates(locationId: string, userId?: string, startDate?: Dayjs, endDate?: Dayjs): Promise<ResponseEnvelope<GetAllBalanceStatesResponse>> {
        try {
            const csrf = await this.getCsrf();
            if (csrf.isFailed()) return new ResponseEnvelope<GetAllBalanceStatesResponse>(false, undefined, csrf.errorTitle, csrf.errorMessage);
            const token = csrf.result!;

            const params = new URLSearchParams();
            if (userId) params.set("userId", userId);
            if (startDate) params.set("startDate", startDate.format("YYYY-MM-DD"));
            if (endDate) params.set("endDate", endDate.format("YYYY-MM-DD"));

            const query = params.toString();
            const url = `${this.protocol}://${this.ip}:${this.port}/api/${locationId}/balancestate${query ? `?${query}` : ""}`;

            var response = await fetch(url, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
            });

            if (!response.ok) return this.invalidResponse();

            var data = await response.json();
            if (!data.success) return this.requestUnsuccessful();

            return new ResponseEnvelope<GetAllBalanceStatesResponse>(
                true,
                data as GetAllBalanceStatesResponse
            );
        } catch (err) {
            if (err instanceof SyntaxError) {
                return this.invalidFormat();
            } else if (err instanceof TypeError) {
                return this.unableToSendRequest();
            } else {
                console.log(err);
                return this.unexpectedError();
            }
        }
    }

    public static async addNewBalanceState(locationId: string, balance: number): Promise<ResponseEnvelope<AddBalanceStateResponse>> {
        try {
            const csrf = await this.getCsrf();
            if (csrf.isFailed()) return new ResponseEnvelope<AddBalanceStateResponse>(false, undefined, csrf.errorTitle, csrf.errorMessage);
            const token = csrf.result!;

            var response = await fetch(`${this.protocol}://${this.ip}:${this.port}/api/${locationId}/balancestate`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
                body: JSON.stringify({
                    balance: balance
                })
            });

            if (!response.ok) return this.invalidResponse();

            var data = await response.json();
            if (!data.success) return this.requestUnsuccessful();

            return new ResponseEnvelope<AddBalanceStateResponse>(
                true,
                data as AddBalanceStateResponse
            );
        } catch (err) {
            if (err instanceof SyntaxError) {
                return this.invalidFormat();
            } else if (err instanceof TypeError) {
                return this.unableToSendRequest();
            } else {
                console.log(err);
                return this.unexpectedError();
            }
        }
    }

    public static async deleteBalanceState(locationId: string, balanceStateId: string): Promise<ResponseEnvelope<DeleteBalanceStateResponse>> {
        try {
            const csrf = await this.getCsrf();
            if (csrf.isFailed()) return new ResponseEnvelope<DeleteBalanceStateResponse>(false, undefined, csrf.errorTitle, csrf.errorMessage);
            const token = csrf.result!;

            var response = await fetch(`${this.protocol}://${this.ip}:${this.port}/api/${locationId}/balancestate/${balanceStateId}`, {
                method: "DELETE",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
            });

            if (!response.ok) return this.invalidResponse();

            var data = await response.json();
            if (!data.success) return this.requestUnsuccessful();

            return new ResponseEnvelope<DeleteBalanceStateResponse>(
                true,
                data as DeleteBalanceStateResponse
            );
        } catch (err) {
            if (err instanceof SyntaxError) {
                return this.invalidFormat();
            } else if (err instanceof TypeError) {
                return this.unableToSendRequest();
            } else {
                console.log(err);
                return this.unexpectedError();
            }
        }
    }
}
